<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        CONVERSATIONS
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">View All Conversations</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-lg-12 paddingLeft50px">
                <div class="nv-list">
                <div>
                <!-- Saved and deployed are one list now; filter by status and folder here -->
                <div class="nv-list-toolbar">
                  <div class="nv-list-filter">
                    <label for="appStatus">Status</label>
                    <nv-select id="appStatus" v-model="statusFilter" @change="filterListByStatus" style="width:230px">
                      <option value="all">All</option>
                      <option value="deployed">Deployed</option>
                      <option value="pending">Changes pending deployment</option>
                      <option value="never">Never deployed</option>
                    </nv-select>
                  </div>
                  <div class="nv-list-filter">
                    <label for="folderName">Folder</label>
                    <nv-select id="folderName" v-model="folderName" @change="filterListByFolder" :disabled="disableFolderSelection" style="width:220px">
                      <option value="">All folders</option>
                      <option v-for="data in folderList" :key="data" :value="data">{{data}}</option>
                    </nv-select>
                  </div>
                  <button type="button" class="btn btn-default" @click="openFolderAddModel()"><i class="fa fa-folder-o"></i> New folder</button>
                  <button type="button" class="btn btn-primary nv-list-toolbar__end" @click="uploadTranslationPopupClick()">Upload Translation</button>
                </div>
                <div class="modal-backdrop" v-if="showFolderAddModel" id="ModelFolderAdd">
                            <div class="modal modal-md" style="height: 200PX;max-width:600px">
                              <header class="modal-header">
                                <slot name="header">
                                  <h3>Create New Folder</h3>
                                </slot>
                                <div class="modal-body">
                                  <slot name="body">
                                  <div class="form-horizontal">
                                    <div class="form-group">
                                      <label for="campaign" style="font-weight:500" class="col-sm-4 control-label">Folder Name</label>
                                      <div class="col-sm-8">
                                        <input type="text" v-bind:class="{'form-group--error': submittedAddFolder && !$v.gRowObjAdd.folderName.required }" v-model="gRowObjAdd.folderName" class="form-control" id="floderNameNew" placeholder="Type name here"  />
                                        <span v-if="submittedAddFolder && !$v.gRowObjAdd.folderName.required" class="text-red pull-right">Please enter folder name.</span>
                                         <span v-if="errorFloderNameAlradyExist" class="text-red pull-right" style="font-size:initial">Folder name already exists</span>
                                      </div>
                                    </div>
                                    <div class="form-group pull-right">
                                      <div class="col-sm-12">
                                        <button type="button" class="btn btn-primary" @click="closeFolderAddModel">Cancel</button>
                                        <button type="button" class="btn btn-primary" @click="AddFolderName">Submit</button>
                                      </div>
                                    </div>
                                  </div>
                                  </slot>
                                </div>
                              </header>
                              <footer class="modal-footer"></footer>
                            </div>
                      </div>

                <div class="row">
                    <div class="col-md-12">
                      <vue-good-table
                        mode="remote"
                        styleClass="vgt-table good-table condensed striped"
                        @on-page-change="onPageChangeForDeployedApps"
                        @on-sort-change="onSortChangeForDeployedApps"
                        @on-column-filter="onColumnFilterForDeployedApps"
                        @on-per-page-change="onPerPageChangeForDeployedApps"
                        :columns="deployedColumns"
                        :rows="deployedApps"
                        :totalRows="deployedAppsCount"
                        :pagination-options="{
                          enabled: true,
                          perPage: 20
                      }">
                        <div slot="emptystate"><nv-empty-state icon="fa-comments-o" title="No conversations found" hint="Try changing the filters, or create a new conversation." action-label="Create conversation" action-to="/conversation/create" /></div>
                      <template slot="loadingContent">
                            <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />
                        <span v-if="props.column.field == 'name'">
                          {{ props.formattedRow[props.column.field]}} <i v-if="props.row.metaData && props.row.metaData.is_new_conversation" class="fa fa-refresh fa-fw" style="cursor:default" title="Synced across all dashboards"></i> 
                        </span>
                        <span v-else-if="!productionMode && props.column.field == 'deployedDate'">
                          {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                        </span>
                        <span v-else-if="productionMode && props.column.field == 'releasedDate'">
                          {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                        </span>
                        <span v-else-if="props.column.field == 'copy'">
                          <i @click="openConversationCopyModel(props.row)" class="fa fa-copy" aria-hidden="true"></i>
                        </span>
                        <span v-else-if="props.column.field == 'folderName'">
                          {{ props.formattedRow[props.column.field]}}
                        </span>
                        <span v-else-if="props.column.field == 'download'">
                          <button class="btn btn-primary" v-on:click="downloadCsvData('deployedApps', props.index)">CSV</button>
                          <button class="btn btn-primary" v-on:click="downloadJson('deployedApps', props.index)">JSON</button>
                        </span>
                        <span v-else-if="props.column.field == 'status'">
                            <span v-if="props.row.deployed" class="nv-status nv-status--deployed" title="The latest save is deployed">Deployed</span>
                            <span v-else-if="props.row.everDeployed" class="nv-status nv-status--pending" title="Deployed before, but the latest saved changes aren't deployed yet">Changes pending deployment</span>
                            <span v-else class="nv-status nv-status--draft" title="Saved but never deployed">Never deployed</span>
                          </span>
                          <span v-else-if="props.column.field == 'savedDate'">
                            {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                          </span>
                          <span v-else-if="props.column.field == 'release'">
                            <button v-if="!props.row.deployed" class="btn btn-primary btn-sm" v-on:click="syncappAcrossInstances(props.index)">Release</button>
                          </span>
                          <span v-else-if="props.column.field == 'organize'">
                          <i @click="openFolderMoveModel(props.row)" class="fa fa-folder fa-2x" aria-hidden="true"></i>
                        </span>
                        <span v-else-if="props.column.field == 'edit'">
                          <router-link :to="`update?app=${props.row.id}`">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </router-link>
                        </span>
                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                      </template>    
                      </vue-good-table>
                    </div>
                    </div>
            
                    <div class="modal-backdrop" v-if="showFolderMoveModel" id="ModelFolderMove">
                      <div class="modal modal-md" style="height: 230PX;max-width:600px">
                        <header class="modal-header">
                          <slot name="header">
                            <h3>Move To Folder</h3>
                          </slot>
                          <div class="modal-body">
                            <slot name="body">
                            <div class="form-horizontal">
                              <div class="form-group">
                                <label for="campaign" style="font-weight:500" class="col-sm-4 control-label">App Name</label>
                                <div class="col-sm-8" style="text-align: left;">
                                  <strong> {{appName}} </strong>
                                </div>
                              </div>
                              <div class="form-group">
                                <label for="campaign" style="font-weight:500" class="col-sm-4 control-label">Choose Folder</label>
                                <div class="col-sm-8">
                                  <nv-select class="form-control"  
                                    id="folderNameMove" v-model="gRowObjMove.folderName">
                                      <option value="">--Choose an option--</option>
                                      <option v-for="data in folderList" :key="data" :value="data" 
                                      :selected="data === gRowObjMove.folderName">{{data}}</option>                      
                                  </nv-select>
                                </div>
                              </div>
                              <div class="form-group pull-right">
                                <div class="col-sm-12">
                                  <button type="button" class="btn btn-primary" @click="closeFolderMoveModel">Cancel</button>
                                  <button type="button" class="btn btn-primary" @click="moveToFolder">Submit</button>
                                </div>
                              </div>
                            </div>
                            </slot>
                          </div>
                        </header>
                        <footer class="modal-footer"></footer>
                      </div>
                    </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
     <div class="modal-backdrop" v-if="showConversationCopyModel" id="ConversationCopy">
      <div class="modal modal-md" style="height: 300PX;max-width:800px">
        <div class="modal-header">
          <slot name="header">
            <h3>Copy Conversation</h3>
          </slot>
        </div>
          <div style="margin: 0px 20px">
            <slot name="body">
              <div class="form-horizontal">
                <div class="form-group">
                  <label for="campaign" style="font-weight:500" class="col-sm-4 control-label">Current App Name</label>
                  <div class="col-sm-8 control-label" style="text-align: left;">
                    <strong> {{conversationToCopy.name}} </strong>
                  </div>
                </div>

                <div class="form-group">
                  <label for="instance" style="font-weight:500" class="col-sm-4 control-label required">Choose Instance(s)</label>
                    <div class="instance-wrapper col-sm-8 ">
                      <div v-for="instance in instances" :key="instance.value" class="instance-checkbox">
                      <label class="checkbox-inline ">
                        <input type="checkbox" v-model="gRowObjConversationCopy.instance" :value="instance.value" />{{instance.name}}
                      </label>
                      </div>
                    </div>
                <span v-if="submittedConversationCopy && !$v.gRowObjConversationCopy.instance.required" class="text-red pull-right" style="margin-right: 20px">Please choose instance(s).</span>
                </div>

                <div class="form-group">
                  <label for="campaign" style="font-weight:500" class="col-sm-4 control-label radio-inline required">New App Name</label>
                  <div class="col-sm-8">
                    <input type="text" v-model="gRowObjConversationCopy.name" class="form-control" id="name" placeholder="New App Name" />
                      <span v-if="submittedConversationCopy && !$v.gRowObjConversationCopy.name.required" class="text-red pull-right">Please enter conversation name.</span>
                      <span v-if="submittedConversationCopy && !$v.gRowObjConversationCopy.name.conversationNameRegex" class="text-red pull-right"> The conversation name can only contain underscore, dash and alphanumeric characters.</span>
                  </div>
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right">
                  <div class="col-sm-12">
                    <button type="button" class="btn btn-primary" @click="closeConversationCopyModel">Cancel</button>
                    <button type="button" class="btn btn-primary" @click="checkConversationAlreadyExists">Copy</button> 
                  </div>
                </div>
          </div>
      </div>
    </div>


     <div class="modal-backdrop" v-if="showConfirmMessage">
      <div class="modal modal-md" style="height: 200PX;max-width:800px">
        <div class="modal-header">
          <slot name="header">
            <h3>Alert</h3>
          </slot>
        </div>
          <div style="margin: 0px 20px">
            <slot name="body">
              <div>You are about to overwrite an existing conversation in instance(s) <b>{{instanceWarning}}</b>. Do you want to continue?</div>
            </slot>
          </div>
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right">
                  <div class="col-sm-12">
                    <button type="button" class="btn btn-primary" @click="CopyConversationAlertNoClick">No, I'll rename it</button>
                    <button type="button" class="btn btn-primary" @click="CopyConversationAlertYesClick">Yes, copy & overwrite</button> 
                  </div>
                </div>
          </div>
      </div>
    </div>

    <div class="modal-backdrop" v-if="(!showConfirmMessage) && showWarningMessage">
      <div class="modal modal-md" style="max-width:800px; height: max-content">
        <div class="modal-header">
          <slot name="header">
            <h3>Warning</h3>
          </slot>
        </div>
          <div style="margin: 20px">
            <slot name="body">
              <div>There are some conversations/keyword linked with the app which you are trying to {{operation}}. Please make sure to perform copy below apps in respective instance(s).</div>
              <div class="warning-text-red">Are you sure you want to proceed without these?</div>
              <div class="copy-warning-app-container">
                <div v-for="data in connectedAppDataForCopy" :key="data.instanceName">
                  <div v-if="data.appsNotPresent.length || data.appsPresentButNeverDeployed.length || data.keywordsNotPresent.length || data.messageTemplatesNotPresent.length">
                    <div style="font-weight: bold; margin-top: 10px">{{data.instanceName}}: </div>
                    <div class="copy-warning-text-div" v-if="data.appsPresentButNeverDeployed.length">
                      Conversation(s) present but never deployed:
                      <ul>
                        <li v-for="app in data.appsPresentButNeverDeployed" :key="app">
                          {{app}}
                        </li>
                      </ul>
                    </div>
                    <div class="copy-warning-text-div" v-if="data.appsNotPresent.length">
                      Conversation(s) not present:
                      <ul>
                        <li v-for="app in data.appsNotPresent" :key="app">
                          {{app}}
                        </li>
                      </ul>
                    </div>
                    <div class="copy-warning-text-div" v-if="data.keywordsNotPresent.length">
                        Keyword(s) not present:
                      <ul>
                        <li v-for="keyword in data.keywordsNotPresent" :key="keyword">
                          {{keyword}}
                        </li>
                      </ul>
                    </div>
                    <div class="copy-warning-text-div" v-if="data.messageTemplatesNotPresent.length">
                        Message Template(s) not present:
                      <ul>
                        <li v-for="template in data.messageTemplatesNotPresent" :key="template">
                          {{template}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </div>
          
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right" style="margin-top: 10px">
              <div class="col-sm-12">
                <button type="button" class="btn btn-primary" @click="CopyConversationWarningNoClick">No, let me check the conversation</button>
                <button type="button" class="btn btn-primary" @click="copyConversationWarningYesClick">Yes, proceed with it</button> 
              </div>
            </div>
          </div>
      </div>
    </div>

    <div class="modal-backdrop" v-if="showTranslationMissingMessage">
      <div class="modal modal-md" style="max-width:800px; height: max-content">
        <div class="modal-header">
          <slot name="header">
            <h3>Warning</h3>
          </slot>
        </div>
          <div style="margin: 20px">
            <slot name="body">
              <div>Below are the stages missing mentioned translations:</div>
              <div class="copy-warning-app-container">
                <table width="100%">
                  <tr>
                    <th width="30%">Stage name</th>
                    <th width="30%">Message</th>
                    <th width="40%">Missing Translation(s)</th>
                  </tr>
                  <tr v-for="(item, index) in missingStages" :key='index'>
                    <td>{{item.stage}}</td>
                    <td>{{item.msgSet}}</td>
                    <td>{{item.missingLang.join(',  ')}}</td>
                  </tr>
                </table>
              </div>
              <div class="warning-text-red" style="margin-top: 20px;">Do you want to proceed with current configuration?</div>
            </slot>
          </div>

          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right" style="margin-top: 10px">
              <div class="col-sm-12">
                <button type="button" class="btn btn-primary" @click="translationMissingWarningNoClick">No, let me check the conversation</button>
                <button type="button" class="btn btn-primary" @click="translationMissingWarningYesClick">Yes, proceed with it</button> 
              </div>
            </div>
          </div>
      </div>
    </div>


    <div class="modal-backdrop" v-if="showUploadTranslationModel" id="translate">
      <div class="modal modal-md" style="height: 420px;max-width:800px">
        <div class="modal-header">
          <slot name="header">
            <h3>Upload Translation</h3>
          </slot>
        </div>
          <div style="margin: 0px 20px; overflow-y: auto; overflow-x: hidden; height: 100%;">
            <slot name="body">
              <div class="form-horizontal">
    
                <div class="form-group">
                  <label for="instance" style="font-weight:500" class="col-sm-4 control-label required">Choose Instance(s)</label>
                    <div class="instance-wrapper col-sm-8 ">
                      <div v-for="instance in instances" :key="instance.value" class="instance-checkbox">
                      <label class="checkbox-inline ">
                        <input type="checkbox" v-model="gRowObjUploadTranslation.instance" :value="instance.value" />{{instance.name}}
                      </label>
                      </div>
                    </div>
                <span v-if="submittedTranslationUpload && !$v.gRowObjUploadTranslation.instance.required" class="text-red pull-right" style="margin-right: 20px">Please choose instance(s).</span>
                </div>

                <div class="form-group">
                  <label for="campaign" style="font-weight:500" class="col-sm-4 control-label radio-inline required">Destination language(s)</label>

                  <div class="col-sm-8 language-treeselect">
                    <treeselect
                      placeholder="--Choose languages--" 
                      :multiple="true" 
                      :options="countryLanguages" 
                      style="min-width:200px;"
                      v-model="gRowObjUploadTranslation.selectedLanguages" 
                      />
                  <span v-if="submittedTranslationUpload && !$v.gRowObjUploadTranslation.selectedLanguages.required" class="text-red pull-right" style="margin-right: 20px">Please choose destination(s).</span>

                  </div>
                </div>

                <div class="form-group">
                  <label for="campaign" style="font-weight:500" class="col-sm-4 control-label radio-inline required">Import file</label>

                  <div class="col-sm-8" style="margin-top: 7px">
                    <div>  
                      <input  @change="onCsvFileChange" type="file" id="csvFile" accept=".csv" />
                    </div>
                      <span v-if="submittedTranslationUpload && !csvData.length" class="text-red pull-right" style="margin-right: 20px">Please select valid CSV file.</span>

                  </div>
                </div>
                <div class="warning-text-red">Note: If the app isn't synced across instances, this only updates the same region of staging or production.</div>
              </div>
            </slot>
          </div>
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right">
                  <div class="col-sm-12">
                    <button type="button" class="btn btn-primary" @click="closeTranslateModel">Cancel</button>
                    <button type="button" class="btn btn-primary" @click="proceedTranslateModel">Translate</button> 
                  </div>
                </div>
          </div>
      </div>
    </div>

    <div class="modal-backdrop" v-if="showTranslatedData">
      <div class="modal modal-md" style="max-width:800px; height: max-content">
        <div class="modal-header">
          <slot name="header">
            <h3>Success</h3>
          </slot>
        </div>
          <div style="margin: 20px">
            <slot name="body">
              <div v-for="([instance, apps],index) in Object.entries(translatedData)" :key='index'>
                Updated app(s) on <b>{{instanceNames[instance]}}</b> : {{apps.map(item => item.name).join(', ')}}
              </div>
              <div class="warning-text-red">Note: Please check the updated translations in the apps and release them to apply the changes.</div>

              <br/>
              <div v-if="missingTranslatedData.length">
                <div >Below are the apps with missing translations. Please check it out.</div>
                  <div class="copy-warning-app-container">
                    <table width="100%">
                      <tr>
                        <th width="20%">Region</th>
                        <th width="20%">App name</th>
                        <th width="20%">Stage name</th>
                        <th width="15%">Message</th>
                        <th width="25%">Missing Translation(s)</th>
                      </tr>
                      <tr v-for="(item, index) in missingTranslatedData" :key='index'>
                        <td>{{item.region}}</td>
                        <td>{{item.app}}</td>
                        <td>{{item.stage}}</td>
                        <td>{{item.msgSet}}</td>
                        <td>{{item.missingLang.join(',  ')}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
            </slot>
          </div>

          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right" style="margin-top: 10px">
              <div class="col-sm-12">
                <button type="button" class="btn btn-primary" @click="translationDataOkClick">OK</button> 
              </div>
            </div>
          </div>
      </div>
    </div>

    <BlockUI v-if="processing"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
  </div>
</template>

<script>
  import { required, helpers } from 'vuelidate/lib/validators'
  import api from '../../../utils/api'
  import { downloadCSV, getEnv, formatDate, validateAllLanguageTranslation, getStagesInBFSOrder, getSelectorValue, getActiveCountryList, isButtonTextGreaterThan20Chars } from '../../../utils/utilities'
  import _ from 'lodash'
  import { languages, instances, instanceNames, domain } from '../../../config/constants'
  import moment from 'moment'
  import flatPickr from 'flatpickr'
  import 'flatpickr/dist/flatpickr.css'
  import { stageTypes } from './constant'

  // Regex to validate conversation name contains only alphanumerics, dash, underscore, and space
  const conversationNameRegex = helpers.regex('alpha', /^[a-zA-Z0-9 _-]*$/)

  export default {
    name: 'view-apps',
    validations: {
      gRowObjAdd: {
        folderName: { required }
      },
      gRowObjConversationCopy: {
        instance: { required },
        name: { required, conversationNameRegex }
      },
      gRowObjUploadTranslation: {
        instance: { required },
        selectedLanguages: { required }
      }
    },
    methods: {
      setActiveTab (tab) {
        this.activeTab = tab
        if (tab === 'saved') {
          this.loadApps()
        }
        console.log('tab', this.activeTab)
      },
      updateParamsForSavedApps (newProps) {
        this.savedTableQueryParams = {...this.savedTableQueryParams, ...newProps}
      },
      onPageChangeForSavedApps (params) {
        this.updateParamsForSavedApps({page: params.currentPage})
        if (this.activeTab) {
          this.loadApps()
        }
      },
      onPerPageChangeForSavedApps (params) {
        this.updateParamsForSavedApps({perPage: params.currentPerPage})
        if (this.activeTab) {
          this.loadApps()
        }
      },
      onSortChangeForSavedApps (params) {
        this.updateParamsForSavedApps({
          sort: {
            [this.savedColumns[params.columnIndex].field]: params.sortType
          }
        })
        if (this.activeTab) {
          this.loadApps()
        }
      },
      onColumnFilterForSavedApps (params) {
        let appliedFilter = {}
        for (const key in params.columnFilters) {
          if (key === 'savedDate') {
            const filterDates = params.columnFilters[key].split(' to ')
            if (filterDates.length && filterDates[0]) {
              appliedFilter['fromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
              appliedFilter['toDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
            }
          } else if (key === 'deployedDate') {
            const filterDates = params.columnFilters[key].split(' to ')
            if (filterDates.length && filterDates[0]) {
              appliedFilter['deployedfromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
              appliedFilter['deployedtoDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
            }
          } else if (key === 'releasedDate') {
            const filterDates = params.columnFilters[key].split(' to ')
            if (filterDates.length && filterDates[0]) {
              appliedFilter['releasedfromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
              appliedFilter['releasedtoDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
            }
          } else if (params.columnFilters[key]) {
            appliedFilter[key] = this.escapeRegExp(params.columnFilters[key])
          }
        }
        this.updateParamsForSavedApps({columnFilters: appliedFilter})
        if (this.activeTab) {
          this.loadApps()
        }
      },
      updateParamsForDeployedApps (newProps) {
        this.deployedTableQueryParams = {...this.deployedTableQueryParams, ...newProps}
      },
      onPageChangeForDeployedApps (params) {
        this.updateParamsForDeployedApps({page: params.currentPage})
        this.loadApps(true)
      },
      onPerPageChangeForDeployedApps (params) {
        this.updateParamsForDeployedApps({perPage: params.currentPerPage})
        this.loadApps(true)
      },
      onSortChangeForDeployedApps (params) {
        this.updateParamsForDeployedApps({
          sort: {
            [this.deployedColumns[params.columnIndex].field]: params.sortType
          }
        })
        this.loadApps(true)
      },
      onColumnFilterForDeployedApps (params) {
        let appliedFilter = {}
        for (const key in params.columnFilters) {
          if (key === 'savedDate') {
            const filterDates = params.columnFilters[key].split(' to ')
            if (filterDates.length && filterDates[0]) {
              appliedFilter['fromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
              appliedFilter['toDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
            }
          } else if (key === 'deployedDate') {
            const filterDates = params.columnFilters[key].split(' to ')
            if (filterDates.length && filterDates[0]) {
              appliedFilter['deployedfromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
              appliedFilter['deployedtoDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
            }
          } else if (key === 'releasedDate') {
            const filterDates = params.columnFilters[key].split(' to ')
            if (filterDates.length && filterDates[0]) {
              appliedFilter['releasedfromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
              appliedFilter['releasedtoDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
            }
          } else if (params.columnFilters[key]) {
            if (key === 'folderName') {
              this.folderName = ''
              this.disableFolderSelection = true
            }
            appliedFilter[key] = this.escapeRegExp(params.columnFilters[key])
          }
        }
        this.updateParamsForDeployedApps({columnFilters: appliedFilter})
        this.loadApps(true)
      },
      escapeRegExp (str) {
        // eslint-disable-next-line
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
      },
      /**
       * @function loadApps
       * @description load all saved/deployed apps
       */
      loadApps () {
        // Saved and deployed apps are one list now, so every reload (including old loadApps() calls
        // after copy/release) fetches that list
        const deployed = true
        return new Promise(resolve => {
          let queryParams = {}
          let isSameParameter = false
          if (!deployed) {
            queryParams = {
              skip: this.savedTableQueryParams.perPage * (this.savedTableQueryParams.page - 1),
              limit: this.savedTableQueryParams.perPage,
              sort: this.savedTableQueryParams.sort,
              selector: getSelectorValue(this.savedTableQueryParams.columnFilters)
            }
            queryParams.selector['type'] = 'CONVERSATION'

            if (JSON.stringify(this.previousQueryParamsForSavedApps) === JSON.stringify(queryParams) && !this.refreshCopiedContent) {
              this.processing = false
              isSameParameter = true
            } else if (JSON.stringify(this.previousQueryParamsForSavedApps.selector) !== JSON.stringify(queryParams.selector) || JSON.stringify(this.previousQueryParamsForSavedApps.sort) !== JSON.stringify(queryParams.sort)) {
              queryParams.skip = 0
              this.savedTableQueryParams.page = 1
            }
          } else {
            queryParams = {
              skip: this.deployedTableQueryParams.perPage * (this.deployedTableQueryParams.page - 1),
              limit: this.deployedTableQueryParams.perPage,
              sort: this.deployedTableQueryParams.sort,
              selector: this.deployedTableQueryParams.columnFilters,
              status: this.statusFilter
            }
            queryParams.selector['type'] = 'CONVERSATION'
            if ((this.folderName && !queryParams.selector.folderName) || (this.folderName && queryParams.selector.folderName && !queryParams.selector.folderName.$options)) {
              queryParams.selector.folderName = this.folderName
            } else if (!this.folderName && queryParams.selector.folderName && this.showAllFoldersContent) {
              delete queryParams.selector.folderName
            }
            queryParams.selector = getSelectorValue(queryParams.selector)

            if (JSON.stringify(this.previousQueryParamsForDeployedApps) === JSON.stringify(queryParams) && !this.refreshFolderData && !this.refreshCopiedContent) {
              this.processing = false
              isSameParameter = true
            } else if (JSON.stringify(this.previousQueryParamsForDeployedApps.selector) !== JSON.stringify(queryParams.selector) || JSON.stringify(this.previousQueryParamsForDeployedApps.sort) !== JSON.stringify(queryParams.sort) || this.previousQueryParamsForDeployedApps.status !== queryParams.status) {
              if ((queryParams.selector.folderName && !queryParams.selector.folderName.$options) || !queryParams.selector.folderName) {
                this.disableFolderSelection = false
              }
              queryParams.skip = 0
              this.deployedTableQueryParams.page = 1
            }
          }
          if (isSameParameter) {
            return
          }
          this.processing = true
          let url = 'apps'
          url += deployed ? `?status=${this.statusFilter}` : ''
          if (deployed) this.previousQueryParamsForDeployedApps = JSON.parse(JSON.stringify(queryParams))
          else this.previousQueryParamsForSavedApps = JSON.parse(JSON.stringify(queryParams))
          api.buildRequest(url, 'POST', queryParams)
            .then(response => {
              if (response.status === 200) {
                if (deployed) {
                  this.deployedApps = response.data.payload.apps
                  this.deployedAppsCount = response.data.payload.appsCount
                  // One list now: Release (syncappAcrossInstances) still reads savedApps by row index
                  this.savedApps = response.data.payload.apps
                  this.savedAppsCount = response.data.payload.appsCount
                  this.copyOfDeployedApps = response.data.payload.apps
                  // this.getFolderList()
                } else {
                  this.savedApps = response.data.payload.apps
                  this.savedAppsCount = response.data.payload.appsCount
                }
                this.processing = false
                if (!this.activeTab) {
                  this.fetchFolders()
                }
              }
              resolve()
            }).catch(({ response }) => {
              this.processing = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
              resolve()
            })
        })
      },

      filterListByStatus () {
        this.loadApps(true)
      },
      filterListByFolder () {
        this.showAllFoldersContent = true
        this.loadApps(true)
        this.showAllFoldersContent = false
      },

      /**
       * @function downloadJson
       * @description downloads the json file
       * @param {string} type - the type of apps (savedApps or deployedApps)
       * @param {number} index - the array index
       */
      downloadJson (type, index) {
        const config = JSON.stringify(this[type][index].config, null, 2)
        const blob = new Blob([config], { type: 'application/json' })
        const url = window.URL.createObjectURL(blob)
        var a = document.createElement('a')
        a.href = url
        a.download = this[type][index].name
        a.textContent = 'Download'
        var event = document.createEvent('MouseEvents')
        event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(event)
      },

      getLanguageName (langName) {
        const languageObj = languages.find(item => item.value === langName)
        if (languageObj) return languageObj.name
        else return langName
      },

      formatDataForCsv (allApps) {
        const fields = ['App Name', 'Stage name', 'Stage Type', 'Next stage(s)', 'Next app', 'Message Sequence']
        const updatedData = []
        allApps.forEach(app => {
          let stagesInBFSOrder = getStagesInBFSOrder(app, false)
          stagesInBFSOrder.forEach(stage => {
            let commonValues = [app.name, stage,
              app.config.stages[stage].stageType ? app.config.stages[stage].stageType : stageTypes.traditional,
              app.config.stages[stage].next ? typeof (app.config.stages[stage].next) !== 'string' ? app.config.stages[stage].next.join() : app.config.stages[stage].next : '',
              app.config.stages[stage].nextApp ? app.config.stages[stage].nextApp : '']
            let record = []
            Object.keys(app.config.stages[stage].text).forEach((text, textIndex) => {
              record.push(JSON.parse(JSON.stringify([...commonValues, ('Message' + (textIndex + 1))])))
              Object.keys(app.config.stages[stage].text[text]).forEach(countryOrLanguage => {
                if (typeof (app.config.stages[stage].text[text][countryOrLanguage]) === 'string') {
                  // Executed when directly languages are associated with text object
                  const languageColumnName = this.getLanguageName(countryOrLanguage)
                  if (fields.indexOf(languageColumnName) < 0) {
                    fields.push(languageColumnName)
                  }
                  if (JSON.parse(JSON.stringify(record[textIndex])).length < fields.length) {
                    record[textIndex].push(...Array(fields.length - record[textIndex].length).fill(null))
                  }
                  record[textIndex][fields.indexOf(this.getLanguageName(countryOrLanguage))] = app.config.stages[stage].text[text][countryOrLanguage]
                } else {
                  // Executed when languages are associated with country and country is associated with text
                  Object.keys(app.config.stages[stage].text[text][countryOrLanguage]).forEach(language => {
                    const countryLanguageColumnName = countryOrLanguage + '/' + this.getLanguageName(language)
                    if (fields.indexOf(countryLanguageColumnName) < 0) {
                      fields.push(countryLanguageColumnName)
                    }
                    if (JSON.parse(JSON.stringify(record[textIndex])).length < fields.length) {
                      record[textIndex].push(...Array(fields.length - record[textIndex].length).fill(null))
                    }
                    record[textIndex][fields.indexOf(countryLanguageColumnName)] = app.config.stages[stage].text[text][countryOrLanguage][language]
                  })
                }
              })
            })

            let dynamicRecords = []
            if (app.config.stages[stage].validations && app.config.stages[stage].validations.type === 'DynamicNumber') {
              Object.keys(app.config.stages[stage].optionConfig).forEach((text, textIndex) => {
                if (app.config.stages[stage].optionConfig[textIndex].dynamic) {
                  dynamicRecords.push([])
                  return
                }
                dynamicRecords.push(JSON.parse(JSON.stringify([...commonValues, ('DynamicOption' + (textIndex + 1))])))
                Object.keys(app.config.stages[stage].optionConfig[textIndex].option_text).forEach(countryOrLanguage => {
                  // Executed when languages are associated with country and text is associated with language
                  Object.keys(app.config.stages[stage].optionConfig[textIndex].option_text[countryOrLanguage]).forEach(language => {
                    const countryLanguageColumnName = countryOrLanguage + '/' + this.getLanguageName(language)
                    if (fields.indexOf(countryLanguageColumnName) < 0) {
                      fields.push(countryLanguageColumnName)
                    }
                    if (JSON.parse(JSON.stringify(dynamicRecords[textIndex])).length < fields.length) {
                      dynamicRecords[textIndex].push(...Array(fields.length - dynamicRecords[textIndex].length).fill(null))
                    }
                    dynamicRecords[textIndex][fields.indexOf(countryLanguageColumnName)] = app.config.stages[stage].optionConfig[textIndex].option_text[countryOrLanguage][language]
                  })
                })
              })
            }

            if (record.length || dynamicRecords.length) {
              // To add all the languages of the stage
              record.forEach(item => {
                if (item.length) updatedData.push(item)
              })
              dynamicRecords.forEach(item => {
                if (item.length) updatedData.push(item)
              })
            } else {
              // Exected When there is no language associated with stage
              updatedData.push(commonValues)
            }
          })
        })

        this.countryLanguages.forEach(item => {
          if (!fields.includes(item.country + '/' + item.language)) {
            fields.push(item.country + '/' + item.language)
          }
        })
        return {fields: fields, data: updatedData}
      },
      /**
       * @function getDataForCSV
       * @description fetch the data from backend for embedded apps up to 4 level deep
       * @param {string} conversation - name of conversation
       * @return {array} Array of conversation
       */
      async getDataForCSV (conversation) {
        this.processing = true
        const url = `getConversationCSVData`
        return api.buildRequest(url, 'GET', { app: conversation })
          .then(response => {
            this.processing = false
            if (response.status === 200) {
              return response.data.payload
            } else {
              this.$swal({
                type: 'error',
                text: response.data.payload.message
              })
            }
          }).catch(({ response }) => {
            this.processing = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      },
      /**
       * @function downloadCsvData
       * @description fetch the data from backend and downloads the csv file
       * @param {string} type - the type of apps (savedApps or deployedApps)
       * @param {number} index - the array index
       */
      async downloadCsvData (type, index) {
        const res = await this.getDataForCSV(this[type][index].name)
        downloadCSV(this.formatDataForCsv(res), res[0].name)
      },

      async getLanguages () {
        await api.buildRequest('languages', 'GET').then(({ data }) => {
          let countryLangObj = data.payload
          for (let country in countryLangObj) {
            if (this.activeCountryArray.includes(country.toLowerCase())) {
              countryLangObj[country].forEach(item => {
                this.countryLanguages.push({
                  country: country,
                  language: item.name,
                  lang: item.iso2,
                  id: country + ':' + item.alias,
                  label: country + '  (' + item.name + ')'
                })
                this.langNameAndAliasObj[item.alias] = item.name
              })
            }
          }
        // this.countryLanguages = data.payload
        })
      },
      uploadTranslationPopupClick () {
        this.showUploadTranslationModel = true
      },
      translationDataOkClick () {
        this.showTranslatedData = false
        this.refreshCopiedContent = true
        this.loadApps()
        this.loadApps(true)
        this.refreshCopiedContent = true
      },
      closeTranslateModel () {
        this.showUploadTranslationModel = false
      },
      proceedTranslateModel () {
        this.submittedTranslationUpload = true
        this.$v.gRowObjUploadTranslation.$touch()
        if (this.$v.gRowObjUploadTranslation.$invalid) {
          return
        }
        if (!this.csvData.length) return
        this.showUploadTranslationModel = false
        console.log('read data from csv', this.csvData)
        console.log('Final: ', _.groupBy(this.csvData, 'App Name'))

        let finalObj = _.groupBy(this.csvData, 'App Name')
        let selectedLang = this.gRowObjUploadTranslation.selectedLanguages.map(item => item.split(':')).map(([country, langAlias]) => `${country}/${this.langNameAndAliasObj[langAlias]}`)
        for (let convName of Object.keys(finalObj)) {
          if (convName) {
            for (let stage of finalObj[convName]) {
              for (let countryLang of Object.keys(stage)) {
                if (selectedLang.includes(countryLang)) {
                  let preStr = `${stage['Stage name']} --> ${stage['Message Sequence']} --> ${countryLang}`
                  let btnArray = stage[countryLang].match(/(?<=\{\{).*?(?=\}\})/g)
                  let optionArray = stage[countryLang].match(/(?<=\[\[).*?(?=\]\])/g)
                  let {resp, error} = this.checkValidations(preStr, btnArray, optionArray, stage[countryLang])
                  if (!resp && error) {
                    this.$swal(error)
                    return
                  }
                }
              }
            }
          }
        }

        let countryLangObj = this.gRowObjUploadTranslation.selectedLanguages.map(item => item.split(':')).map(([key, value]) => ({[key]: value}))
        let countryWiseLang = {}
        for (let langObj of countryLangObj) {
          if (countryWiseLang[Object.keys(langObj)[0]]) {
            countryWiseLang[Object.keys(langObj)[0]].push(Object.values(langObj)[0])
          } else {
            countryWiseLang[Object.keys(langObj)[0]] = [Object.values(langObj)[0]]
          }
        }

        let instanceData = []

        this.gRowObjUploadTranslation.instance.forEach(record => {
          instanceData.push(record + '-ap-south-1', record + '-eu-central-1')
        })

        let params = {
          csvData: _.groupBy(this.csvData, 'App Name'),
          instances: instanceData,
          // selectedLanguages: this.selectedLanguages.map(item => item.split(':')).map(([key, value]) => ({[key]: value})),
          selectedLanguages: countryWiseLang
        }
        this.processing = true
        api.buildRequest('uploadTranslationFromCSV', 'POST', params)
            .then(async (response) => {
              this.gRowObjUploadTranslation.selectedLanguages = []
              this.gRowObjUploadTranslation.instance = []
              this.submittedTranslationUpload = false
              this.processing = false
              if (response.status === 200) {
                this.showTranslatedData = true
                this.translatedData = response.data.payload
                this.missingTranslatedData = []
                // check missing translation
                for (const [instance, apps] of Object.entries(this.translatedData)) {
                  apps.forEach(app => {
                    let missingStages = validateAllLanguageTranslation(Object.values(app.config.stages))
                    console.log('missingStages: ', missingStages)
                    if (missingStages.length) {
                      missingStages.forEach(stg => {
                        this.missingTranslatedData.push({
                          region: instanceNames[instance],
                          app: app.name,
                          ...stg
                        })
                      })
                    }
                    console.log(this.missingTranslatedData)
                  })
                }
              } else {
                this.$swal({
                  title: 'Upload Translation Error',
                  type: 'error',
                  html: response.data.payload.message
                })
              }
            }).catch(({response}) => {
              this.$swal({
                title: 'Upload Translation Error',
                type: 'error',
                html: response.data.payload.message
              })
              this.processing = false
            })
      },
      checkValidations (preStr, btnArray, optionArray, messageText) {
        if (btnArray || optionArray) {
          let messageAfterButtonOrListRemoved = messageText.trim().replace(/{{(.+?)}}|\[\[(.*?)\]\]/g, '')
          if (!messageAfterButtonOrListRemoved) {
            return {
              resp: false,
              error: {
                type: 'error',
                html: `<h4><b>${preStr}</b></h4>
                <h5>Please enter some plain text while using Buttons and Lists</h5>`
              }
            }
          }
        }
        if (Array.isArray(btnArray)) {
          for (let str of btnArray) {
            str = str.trim()
            if (!str) {
              return {
                resp: false,
                error: {
                  type: 'error',
                  html: `<h4><b>${preStr}</b></h4>
                  <h5>Please Add Button text</h5>`
                }
              }
            } else if (isButtonTextGreaterThan20Chars(str)) {
              return {
                resp: false,
                error: {
                  type: 'error',
                  html: `<h4><b>${preStr}</b></h4>
                  <h5>Button text should be less than 20 characters</h5>`
                }
              }
            }
          }
        }
        if (Array.isArray(btnArray) && btnArray.length > 10) {
          return {
            resp: false,
            error: {
              type: 'error',
              html: `<h4><b>${preStr}</b></h4> 
              <h5>Maximum of 10 options allowed for buttons/lists.</h5>
              <h5>Please use plain text format if more than 10 options are needed.</h5>`
            }
          }
        }
        if ((Array.isArray(btnArray) && btnArray.length <= 3) && (Array.isArray(optionArray) && optionArray.length)) {
          return {
            resp: false,
            error: {
              type: 'error',
              html: `<h4><b>${preStr}</b></h4> 
              <h5>List options not needed for less then 3 buttons</h5>`
            }
          }
        }
        if ((Array.isArray(btnArray) && btnArray.length > 3 && !btnArray[0].includes('NINETY')) && (!optionArray || !optionArray.length)) {
          return {
            resp: false,
            error: {
              type: 'error',
              html: `<h4><b>${preStr}</b></h4>
              <h5>List options needed for more than 3 buttons.</h5>
              <h5>Please add list option like [[List Button Text]]</h5>`
            }
          }
        }
        if ((!btnArray || !btnArray.length) && (Array.isArray(optionArray) && optionArray.length)) {
          return {
            resp: false,
            error: {
              type: 'error',
              html: `<h4><b>${preStr}</b></h4> 
              <h5>Add list option when more then 3 buttons</h5>`
            }
          }
        }
        if (Array.isArray(optionArray)) {
          for (let str of optionArray) {
            str = str.trim()
            if (!str) {
              return {
                resp: false,
                error: {
                  type: 'error',
                  html: `<h4><b>${preStr}</b></h4>
                  <h5>Please Add list option text</h5>`
                }
              }
            } else if (isButtonTextGreaterThan20Chars(str)) {
              return {
                resp: false,
                error: {
                  type: 'error',
                  html: `<h4><b>${preStr}</b></h4>
                  <h5>List option text should be less than 20 characters</h5>`
                }
              }
            }
          }
        }
        if (Array.isArray(optionArray) && optionArray.length > 1) {
          return {
            resp: false,
            error: {
              type: 'error',
              html: `<h4><b>${preStr}</b></h4> 
              <h5>There should be only one list option</h5>`
            }
          }
        }

        return {resp: true, error: null}
      },
      onCsvFileChange (e) {
        console.log('on csv file change')
        const file = e.target.files[0]
        const reader = new FileReader()
        reader.onload = e => {
          const text = e.target.result
          const data = this.csvToArray(text)

          this.csvData = data
        }
        // reader.onload = e => console.log(e.target.result)
        reader.readAsText(file)
      },
      getRowData (text) {
        let p = ''
        let row = ['']
        let ret = [row]
        let i = 0
        let r = 0
        let s = !0
        let l
        for (l of text) {
          if (l === '"') {
            if (s && l === p) row[i] += l
            s = !s
          } else if (l === ',' && s) l = row[++i] = ''
          else if (l === '\n' && s) {
            if (p === '\r') row[i] = row[i].slice(0, -1)
            row = ret[++r] = [l = '']; i = 0
          } else row[i] += l
          p = l
        }
        return ret
      },
      csvToArray (str, delimiter = ',') {
        // slice from start of text to the first \n index
        // use split to create an array from string by delimiter

        const headers = str.slice(0, str.indexOf('\n')).split(delimiter).map(item => item.replace(/(^"|"$)/g, '').replace('\r\n', '').replace('\r', '').replace('\n', ''))
        console.log('headers: ', headers)

        // slice from \n index + 1 to the end of the text
        // use split to create an array of each csv value row

        console.log('str.slice', str.slice(str.indexOf('\n') + 1))
        const rows = this.getRowData(str.slice(str.indexOf('\n') + 1))
        console.log('rows: ', rows)

        // Map the rows
        // split values from each row into an array
        // use headers.reduce to create an object
        // object properties derived from headers:values
        // the object passed as an element of the array
        const arr = rows.map(function (row) {
          const el = headers.reduce(function (object, header, index) {
            object[header] = row[index]
            return object
          }, {})
          return el
        })

        // return the array
        return arr
      },

      /**
       * @function release
       * @description promote the current app to production
       * @param {number} index - the index of the app in the deployedApps array
       */
      release (index) {
        this.processing = true
        const appId = this.deployedApps[index].id
        const url = `app/${appId}?name=${this.deployedApps[index].name}`
        api.buildRequest(url, 'PUT', { config: this.deployedApps[index].config, metaData: this.deployedApps[index].metaData })
          .then(response => {
            this.processing = false
            this.$swal({
              type: response.status === 200 ? 'success' : 'error',
              text: response.data.payload.message
            })
            if (response.status === 200) {
              // this
            }
          }).catch(({ response }) => {
            this.processing = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      },

      /**
       * @function syncappAcrossInstances
       * @description syncappAcrossInstances
       * @param {number} index - the index of the app in the savedApps array
       */
      async syncappAcrossInstances (index) {
        this.processing = true
        this.operation = 'release'
        this.indexOfReleasedConvo = index

        this.missingStages = validateAllLanguageTranslation(Object.values(this.savedApps[index].config.stages))
        if (this.missingStages.length && !this.overrideTranslationMissing) {
          this.processing = false
          this.showTranslationMissingMessage = true
          return
        }

        try {
          const savedAppResp = await api.buildRequest('app', 'POST', { name: this.savedApps[index].name, config: this.savedApps[index].config, metaData: this.savedApps[index].metaData, foldername: this.savedApps[index].folderName })
          this.overrideTranslationMissing = false
          if (savedAppResp.status !== 200) {
            throw savedAppResp
          }
          const deployedAppResp = await api.buildRequest('syncappAcrossInstances', 'POST', { config: this.savedApps[index].config, metaData: this.savedApps[index].metaData, __v: 1, allowDeployWithWarning: this.allowDeployWithWarning, folderName: this.savedApps[index].folderName })
          console.log('deployedAppResponse', deployedAppResp)
          if (deployedAppResp.status === 206) {
            this.showWarningMessage = true
            this.connectedAppDataForCopy = deployedAppResp.data.payload.data
            this.processing = false
            return
          } else if (deployedAppResp.status !== 200) {
            throw deployedAppResp
          }
          this.processing = false
          this.allowDeployWithWarning = false
          try {
            await api.buildRequest('llm-cache/invalidate', 'POST', {
              type: 'conversation',
              app_names: [this.savedApps[index].name],
              invalidate: true
            })
          } catch (err) {
            console.warn('Cache invalidation failed:', err.message)
          }
          this.$swal({
            title: 'Release Conversation',
            type: 'success',
            text: deployedAppResp.data.payload.message
          }).then(() => {
            this.refreshFolderData = true
            this.refreshCopiedContent = true
            this.loadApps()
            this.loadApps(true)
            this.refreshFolderData = false
            this.refreshCopiedContent = false
          })
        } catch (error) {
          this.allowDeployWithWarning = false
          this.$swal({
            title: 'Release Conversation',
            type: 'error',
            html: error.data.payload.message
          })
          this.processing = false
        }
      },

      /**
       * @author Sarang Sutar <sarang.sutar@mobifilia.com>
       * @function searchConversation
       * @description search the conversation of interest among all the conversations
       * @param {event} event - Event of the search box for conversation
       */
      searchConversations (event) {
        if (event === 'folder') {
          this.searchConversation = ''
        }
        let folderName = this.folderName
        let searchedConversation = this.searchConversation

        if (this.searchConversation !== '' && this.searchConversation !== undefined) {
          this.processing = true
          this.deployedApps = _.filter(this.copyOfDeployedApps, function (app) {
            if (folderName) {
              if (app.name.toLowerCase().includes(searchedConversation.toLowerCase()) && folderName === app.folderName) {
                return app
              }
            } else {
              if (app.name.toLowerCase().includes(searchedConversation.toLowerCase())) {
                return app
              }
            }
          })
          this.processing = false
          console.log('deployedApps', this.deployedApps)
        } else if (this.folderName) {
          this.processing = true
          this.deployedApps = _.filter(this.copyOfDeployedApps, function (app) {
            if (folderName && searchedConversation) {
              if (app.name.toLowerCase().includes(searchedConversation.toLowerCase()) && folderName === app.folderName) {
                return app
              }
            } else if (folderName) {
              if (folderName === app.folderName) {
                return app
              }
            } else if (searchedConversation) {
              if (app.name.toLowerCase().includes(searchedConversation.toLowerCase())) {
                return app
              }
            }
          })
          this.processing = false
          console.log(this.deployedApps)
        } else if (!this.folderName && !this.searchConversation) {
          this.processing = true
          this.deployedApps = _.filter(this.copyOfDeployedApps, function (app) {
            if (!app.folderName) {
              return app
            }
          })
          this.processing = false
          console.log(this.deployedApps)
        }
      },
      getFolderList () {
        for (const app of this.copyOfDeployedApps) {
          if (app.folderName) {
            this.folderList.push({
              folderName: app.folderName
            })
          }
        }
        this.folderList = _.uniqBy(this.folderList, 'folderName')
      },
      openFolderAddModel () {
        this.gRowObjAdd.folderName = ''
        this.errorFloderNameAlradyExist = false
        this.showFolderAddModel = true
        this.submittedAddFolder = false
      },
      closeFolderAddModel () {
        this.gRowObjAdd.folderName = ''
        this.errorFloderNameAlradyExist = false
        this.showFolderAddModel = false
        this.submittedAddFolder = false
      },
      AddFolderName () {
        let isFolderNameAlreadyExist = false
        this.errorFloderNameAlradyExist = false
        this.submittedAddFolder = true
        this.$v.gRowObjAdd.$touch()
        if (this.$v.gRowObjAdd.$invalid) {
          return
        }
        for (const folder of this.folderList) {
          if (folder.toLowerCase().includes(this.gRowObjAdd.folderName.toLowerCase())) {
            isFolderNameAlreadyExist = true
          }
        }
        if (isFolderNameAlreadyExist) {
          this.errorFloderNameAlradyExist = true
        } else {
          this.folderList.push(this.gRowObjAdd.folderName)
          this.gRowObjAdd.folderName = ''
          this.showFolderAddModel = false
        }
      },
      checkConversationAlreadyExists () {
        this.submittedConversationCopy = true
        this.$v.gRowObjConversationCopy.$touch()
        if (this.$v.gRowObjConversationCopy.$invalid) {
          return
        }
        this.operation = 'copy'
        if (this.gRowObjConversationCopy.instance.length && this.gRowObjConversationCopy.name) {
          let appsToCheck = new Set()
          let keywordsToCheck = new Set()
          let messageTemplatesToCheck = new Set()
          for (var key in this.conversationToCopy.config.stages) {
            if (this.conversationToCopy.config.stages[key].stageType === 'embedded_conversation' &&
              this.conversationToCopy.config.stages[key].conversation.split('###').length > 1
            ) {
              appsToCheck.add(this.conversationToCopy.config.stages[key].conversation.split('###')[1])
            }
            if (this.conversationToCopy.config.stages[key].nextApp &&
              this.conversationToCopy.config.stages[key].nextApp.split('###').length > 1
            ) {
              appsToCheck.add(this.conversationToCopy.config.stages[key].nextApp.split('###')[1])
            }

            if (this.conversationToCopy.config.stages[key].scheduledAppKeyword) {
              if (typeof this.conversationToCopy.config.stages[key].scheduledAppKeyword === 'string') {
                // If it's a string, process it directly
                const parts = this.conversationToCopy.config.stages[key].scheduledAppKeyword.split('###')
                if (parts.length > 1) {
                  appsToCheck.add(parts[1])
                } else {
                  keywordsToCheck.add(this.conversationToCopy.config.stages[key].scheduledAppKeyword)
                }
              } else if (Array.isArray(this.conversationToCopy.config.stages[key].scheduledAppKeyword)) {
                // If it's an array, process each element
                this.conversationToCopy.config.stages[key].scheduledAppKeyword.forEach(keyword => {
                  const parts = keyword.split('###')
                  if (parts.length > 1) {
                    appsToCheck.add(parts[1])
                  } else {
                    keywordsToCheck.add(keyword)
                  }
                })
              }
            }
            if (this.conversationToCopy.config.stages[key].jorTemplateName) {
              messageTemplatesToCheck.add(this.conversationToCopy.config.stages[key].jorTemplateName)
            }
            if (this.conversationToCopy.config.stages[key].msgTemplateName) {
              messageTemplatesToCheck.add(this.conversationToCopy.config.stages[key].msgTemplateName)
            }
          }

          let appForBothInstance = []
          this.gRowObjConversationCopy.instance.map((record, index) => {
            console.log(index)
            appForBothInstance.push({
              instance: record + '-ap-south-1',
              name: this.gRowObjConversationCopy.name.trim(),
              appsToCheck: [...appsToCheck],
              keywordsToCheck: [...keywordsToCheck],
              messageTemplatesToCheck: [...messageTemplatesToCheck]
            }, {
              instance: record + '-eu-central-1',
              name: this.gRowObjConversationCopy.name.trim(),
              appsToCheck: [...appsToCheck],
              keywordsToCheck: [...keywordsToCheck],
              messageTemplatesToCheck: [...messageTemplatesToCheck]
            })
          })
          this.showConversationCopyModel = false
          this.processing = true

          api.buildRequest('copyapp/checkexistance', 'POST', JSON.parse(JSON.stringify(appForBothInstance)))
              .then(response => {
                if (response.status === 200 && response.data.payload.length) {
                  console.log('Setting insert warning')
                  this.processing = false
                  let duplicateNameData = []
                  let warningMessage = false

                  response.data.payload.forEach(function (item) {
                    if (item.duplicateConv) {
                      duplicateNameData.push(item.instanceName)
                    }
                    if (item.appsNotPresent.length || item.appsPresentButNeverDeployed.length || item.keywordsNotPresent.length || item.messageTemplatesNotPresent.length) {
                      warningMessage = true
                    }
                  })

                  if (duplicateNameData.length) {
                    // Show confirm copy for duplicate name conversation
                    this.showConfirmMessage = true
                    this.instanceWarning = duplicateNameData.join(' & ')
                  }

                  // Show warning mesaage for connect apps
                  this.showWarningMessage = warningMessage
                  this.connectedAppDataForCopy = response.data.payload

                  if (!(this.showWarningMessage || this.showConfirmMessage)) {
                    this.copyConversation()
                  }
                } else {
                  this.showConversationCopyModel = true
                  this.$swal({
                    title: 'Copy Conversation',
                    type: 'error',
                    html: response.data.payload.message
                  })
                }
              }).catch(({response}) => {
                this.$swal({
                  title: 'Copy Conversation',
                  type: 'error',
                  html: response.data.payload.message
                })
                this.processing = false
              })
        }
      },
      async copyConversation () {
        this.submittedConversationCopy = true
        if (this.gRowObjConversationCopy.instance.length && this.gRowObjConversationCopy.name) {
          let newApp = JSON.parse(JSON.stringify(this.conversationToCopy))
          if (this.conversationToCopy.__v === 0) {
            const domainname = window.location.hostname
            const country = (this.env && this.env.country) ? this.env.country : domain[domainname].defaultConversationCountry
            var stages = JSON.parse(JSON.stringify(this.conversationToCopy.config.stages))
            for (var stageObj in stages) {
              var textCountry = []
              stages[stageObj].text.forEach(function (messageSet) {
                var textCountryObj = {}
                var defaultCountry = 'Global'
                textCountryObj[country] = {}
                textCountryObj[defaultCountry] = {}
                for (var lang in messageSet) {
                  if (lang === 'properties') {
                    textCountryObj[lang] = messageSet[lang]
                  } else {
                    textCountryObj[country][lang] = messageSet[lang]
                    if (lang === 'eng') {
                      textCountryObj[defaultCountry][lang] = messageSet[lang]
                    }
                  }
                }
                textCountry.push(textCountryObj)
                stages[stageObj].text = textCountry
              })
            }
            newApp.config.stages = stages
          }
          let copiedConversationId = newApp.id
          delete newApp.id
          delete newApp.deployedDate
          delete newApp.releasedDate
          delete newApp.createdAt
          delete newApp.updatedAt
          delete newApp.savedDate
          newApp.deployed = false
          newApp.name = this.gRowObjConversationCopy.name.trim()
          newApp.config.name = this.gRowObjConversationCopy.name.trim()
          newApp.__v = 1
          newApp.config.stages && Object.entries(newApp.config.stages).forEach(([key, value]) => {
            delete value.questionId
          })
          let appForBothInstance = []
          console.log(newApp)
          this.gRowObjConversationCopy.instance.map((record, index) => {
            console.log(index)
            newApp.metaData = {
              ...newApp.metaData,
              is_new_conversation: true,
              copied_conversation_id: copiedConversationId,
              last_copied_from: instanceNames[this.env.env + '-' + this.env.region]
            }
            appForBothInstance.push({
              instance: record + '-ap-south-1',
              ...newApp
            }, {
              instance: record + '-eu-central-1',
              ...newApp
            })
          })
          console.log(JSON.parse(JSON.stringify(appForBothInstance)))
          this.processing = true
          this.showConversationCopyModel = false
          api.buildRequest('copyapp', 'POST', JSON.parse(JSON.stringify(appForBothInstance)))
            .then(async (response) => {
              this.gRowObjConversationCopy.name = ''
              this.gRowObjConversationCopy.instance = []
              this.showConversationCopyModel = false
              this.submittedConversationCopy = false
              this.processing = false
              this.$swal({
                title: 'Copy Conversation',
                type: response.status === 200 ? 'success' : 'error',
                html: Array.isArray(response.data.payload) ? response.data.payload.map(i => i.message).join('<br/>') : response.data.payload.message
              }).then(() => {
                this.refreshCopiedContent = true
                this.loadApps(true)
                this.loadApps()
                this.refreshCopiedContent = false
              })
            }).catch(({response}) => {
              this.$swal({
                title: 'Copy Conversation',
                type: 'error',
                html: response.data.payload.message
              })
              this.processing = false
            })
        }
      },
      CopyConversationAlertNoClick () {
        this.showConfirmMessage = false
        this.showWarningMessage = false
        this.showConversationCopyModel = true
      },
      CopyConversationAlertYesClick () {
        this.showConversationCopyModel = false
        this.showConfirmMessage = false
        if (!this.showWarningMessage) {
          this.copyConversation()
        }
      },
      CopyConversationWarningNoClick () {
        this.showWarningMessage = false
        this.gRowObjConversationCopy.name = ''
        this.gRowObjConversationCopy.instance = []
        this.submittedConversationCopy = false
      },
      copyConversationWarningYesClick () {
        this.showWarningMessage = false
        if (this.operation === 'copy') {
          this.copyConversation()
        } else {
          this.allowDeployWithWarning = true
          this.syncappAcrossInstances(this.indexOfReleasedConvo)
        }
      },
      translationMissingWarningNoClick () {
        this.showTranslationMissingMessage = false
      },
      translationMissingWarningYesClick () {
        this.showTranslationMissingMessage = false
        this.overrideTranslationMissing = true
        this.missingStages = []
        this.syncappAcrossInstances(this.indexOfReleasedConvo)
      },
      openConversationCopyModel (item) {
        this.showConversationCopyModel = true
        this.conversationToCopy = item
      },
      closeConversationCopyModel () {
        this.showConversationCopyModel = false
        this.submittedConversationCopy = false
        this.conversationToCopy = null
      },
      openFolderMoveModel (item) {
        this.showFolderMoveModel = true
        this.folderIdMove = item.id
        this.gRowObjMove.folderName = item.folderName || ''
        this.appName = item.name
      },
      closeFolderMoveModel () {
        this.folderIdMove = ''
        this.showFolderMoveModel = false
        this.gRowObjMove.folderName = ''
        this.appName = ''
      },
      async fetchFolders () {
        try {
          this.processing = true
          const response = await api.buildRequest('app/folders', 'POST', {type: {$nin: ['journey', 'journeyReminder']}})
          this.folderList = response.data.payload.folders
          this.processing = false
        } catch (error) {
          this.processing = false
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },
      moveToFolder () {
        var conversationToMove = this.copyOfDeployedApps.find((item) => this.folderIdMove === item.id)
        conversationToMove.folderName = this.gRowObjMove.folderName
        console.log(this.folderIdMove)
        return new Promise(resolve => {
          this.processing = true
          const param = {
            appId: this.folderIdMove,
            folderName: this.gRowObjMove.folderName,
            conversationToMove
          }
          api.buildRequest('conversationMoveToFolder', 'POST', param).then(({ data }) => {
            for (let app of this.copyOfDeployedApps) {
              if (app.id === this.folderIdMove) {
                app.folderName = this.gRowObjMove.folderName
              }
            }
            for (let app of this.deployedApps) {
              if (app.id === this.folderIdMove) {
                app.folderName = this.gRowObjMove.folderName
              }
            }
            this.showFolderMoveModel = false
            this.folderIdMove = ''
            this.gRowObjMove.folderName = ''
            this.processing = false
            this.appName = ''
            this.$swal({
              type: 'success',
              text: data ? data.payload.message : 'Updated Folder of App'
            })
            this.refreshFolderData = true
            this.fetchFolders()
            this.loadApps(true)
            this.refreshFolderData = false
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.processing = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      }
    },
    computed: {
      productionMode () {
        return process.env.NODE_ENV === 'production' && !window.location.href.includes('staging') && !window.location.href.includes('heroku')
      }
    },
    watch: {
      searchConversation: function () {
        if (this.searchConversation === '' && this.folderName === '') {
          // this.deployedApps = this.copyOfDeployedApps
        }
      },
      folderName: function () {
        if (this.searchConversation === '' && this.folderName === '') {
          // this.deployedApps = this.copyOfDeployedApps
        }
      }
    },
    data () {
      return {
        formatDate: formatDate,
        missingStages: [],
        countryLanguages: [],
        langNameAndAliasObj: {},
        showUploadTranslationModel: false,
        csvData: [],
        missingTranslatedData: [],
        submittedTranslationUpload: false,
        instanceNames: instanceNames,
        showTranslatedData: false,
        translatedData: {},
        gRowObjUploadTranslation: {
          instance: [],
          selectedLanguages: []
        },
        showTranslationMissingMessage: false,
        overrideTranslationMissing: false,
        env: '',
        savedApps: [],
        savedAppsCount: 0,
        deployedAppsCount: 0,
        deployedApps: [],
        copyOfDeployedApps: [],
        processing: true,
        searchConversation: '',
        instanceWarning: '',
        showConfirmMessage: false,
        showWarningMessage: false,
        connectedAppDataForCopy: [],
        folderName: '',
        folderList: [],
        conversationToCopy: null,
        showConversationCopyModel: false,
        showFolderAddModel: false,
        showFolderMoveModel: false,
        instances: instances,
        errorFloderNameAlradyExist: false,
        submittedAddFolder: false,
        refreshFolderData: false,
        showAllFoldersContent: false,
        refreshCopiedContent: false,
        disableFolderSelection: false,
        activeTab: '',
        statusFilter: 'all',
        gRowObjAdd: {
          folderName: ''
        },
        folderIdMove: '',
        appName: '',
        gRowObjMove: {
          folderName: ''
        },
        gRowObjConversationCopy: {
          instance: [],
          name: ''
        },
        submittedMoveFolder: false,
        submittedConversationCopy: false,
        savedTableQueryParams: {
          columnFilters: {},
          sort: {
            savedDate: 'desc'
          },
          page: 1,
          perPage: 20
        },
        deployedColumns: [
          {
            label: 'Application Name',
            field: 'name',
            sortable: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Search Application Name'
            }
          },
          {
            label: 'Status',
            field: 'status',
            sortable: false
          },
          {
            label: 'Last Saved Date',
            field: 'savedDate',
            sortable: true,
            filterable: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Select Date Range'
            }
          },
          {
            label: 'Organize',
            field: 'organize',
            sortable: false
          },
          {
            label: 'Folder Name',
            field: 'folderName',
            sortable: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Search folder name'
            }
          },
          {
            label: 'Last Deployed Date',
            field: 'deployedDate',
            sortable: true,
            filterable: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Select Date Range'
            }
          },
          {
            label: 'Last Released Date',
            field: 'releasedDate',
            sortable: true,
            filterable: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Select Date Range'
            }
          },
          {
            label: 'Copy',
            field: 'copy',
            sortable: false
          },
          {
            label: 'Edit',
            field: 'edit',
            sortable: false
          },
          {
            label: 'Download',
            field: 'download',
            sortable: false
          },
          {
            label: 'Release',
            field: 'release',
            sortable: false
          }
        ],
        deployedTableQueryParams: {
          columnFilters: {},
          sort: {
            savedDate: 'desc'
          },
          page: 1,
          perPage: 20
        },
        savedColumns: [
          {
            label: 'Application Name',
            field: 'name',
            sortable: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Search Application Name'
            }
          },
          {
            label: 'Last Saved Date',
            field: 'savedDate',
            sortable: true,
            filterable: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Select Date Range'
            }
          },
          {
            label: 'Last Deployed Date',
            field: 'deployedDate',
            sortable: true,
            filterable: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Select Date Range'
            }
          },
          {
            label: 'Last Released Date',
            field: 'releasedDate',
            sortable: true,
            filterable: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Select Date Range'
            }
          },
          {
            label: 'Copy',
            field: 'copy',
            sortable: false
          },
          {
            label: 'Edit',
            field: 'edit',
            sortable: false
          },
          {
            label: 'Download',
            field: 'download',
            sortable: false
          },
          {
            label: 'Release',
            field: 'release',
            sortable: false
          }
        ],
        previousQueryParamsForDeployedApps: {},
        previousQueryParamsForSavedApps: {},
        operation: 'copy',
        allowDeployWithWarning: false,
        indexOfReleasedConvo: null,
        activeCountryArray: []
      }
    },
    async mounted () {
      this.activeCountryArray = await getActiveCountryList('lowercase', true)
      flatPickr('input[placeholder="Select Date Range', {
        dateFormat: 'd-m-Y',
        mode: 'range',
        allowInput: true,
        onClose: function (selectedDates, dateStr, instance) {
          if (selectedDates.length === 1) {
            instance.setDate([selectedDates[0], selectedDates[0]], true)
          }
        }
      })
      this.env = await getEnv()
      this.savedColumns = this.savedColumns.filter(item => {
        if (item.field === 'deployedDate' && this.env.env === 'production') {
          return false
        } else if (item.field === 'releasedDate' && this.env.env === 'staging') {
          return false
        } else return true
      })
      this.deployedColumns = this.deployedColumns.filter(item => {
        if (item.field === 'deployedDate' && this.env.env === 'production') {
          return false
        } else if (item.field === 'releasedDate' && this.env.env === 'staging') {
          return false
        } else return true
      })
      this.loadApps(true)
      this.getLanguages()
    }
  }
</script>
<style scoped>
 ul {
   margin: 0px
 }
 .copy-warning-text-div {
   margin-left: 20px;
 }
</style>
<style>
  th {
    padding-left: 8px;
  }
  .copy-warning-app-container {
    max-height: 300px;
    margin-top: 20px;
    overflow: auto;
  }
  .width-60-px {
    width: 60px;
  }
  .value {
    font-weight: bold;
  }
  .box-body {
    min-height: calc(100vh - 171px);
  }
  .form-loader img {
    width: 30px;
    height: 30px;
  }
  .action-button {
    clear: both;
    display: flex;
    justify-content: center;
  }
  .table-apps {
    margin-top: 20px;
  }
  .paddingLeft50px {
    padding-left: 50px;
  }
  .searchconversation label {
    color: #333;
    height: 20px;
    width: 200px;
    margin-top: 16px;
    margin-left: 10px;
    text-align: right;
    clear: both;
    float:left;
    margin-right:15px;
}
.searchconversation input {
    width: 300px;
    margin-top: 10px;
    float: left;
}
.instance-wrapper {
	display: flex;
  text-align: justify;
	justify-content: space-between;
	flex-wrap: wrap;
}
.instance-checkbox {
	width: 50%;
}
.warning-text-red {
  color: red;
  font-weight: bold;
}
.vgt-loading__content {
  display: none;
}
input[type=file]:focus {
  outline: none;
}
.language-treeselect .vue-treeselect__menu {
  max-height: unset !important;
}
</style>



// WEBPACK FOOTER //
// view.vue?01daa734